import beforeEnter from '../utils'

export default {
  path: '/orcamento/:id',
  component: () => import('@/App.vue'),
  beforeEnter: (to, from, next) => beforeEnter(to, from, next),
  children: [
    {
      path: '',
      component: () => import('@/pages/Layout.vue'),
      children: [
        {
          path: ':cd_fornecedor/:cd_pedido',
          name: 'orcamento',
          component: () => import('@/pages/Orcamento/Home.vue')
        },
        {
          path: '',
          name: 'index',
          component: () => import('@/pages/Orcamento/Index.vue')
        }
      ]
    }
  ]
}
